import { GlobalState } from '../../../store/global';
import { createSelector } from '@ngrx/store';
import { sessionEntityAdapter, sessionsEntityAdapter } from './ai-insights-adapters';

const featureState = (state: GlobalState) => state.aiInsights;
export const selectChatSessionId = createSelector(featureState, (state) => state.sessionId);
export const selectChatSuggestions = createSelector(featureState, (state) => state.chatSuggestions);
export const selectSessionPage = createSelector(featureState, (state) => state.sessionPage);
export const selectSessionTotalPages = createSelector(featureState, (state) => state.sessionTotalPages);
export const selectSessionPageSize = createSelector(featureState, (state) => state.sessionPageSize);
export const selectSessionsPage = createSelector(featureState, (state) => state.sessionsPage);
export const selectSessionsTotalPages = createSelector(featureState, (state) => state.sessionsTotalPages);
export const selectSessionsPageSize = createSelector(featureState, (state) => state.sessionsPageSize);

const sessionSelectors = sessionEntityAdapter.getSelectors();
const selectSessionEntity = createSelector(featureState, (state) => state.session);
const sessionsSelectors = sessionsEntityAdapter.getSelectors();
const selectSessionsEntity = createSelector(featureState, (state) => state.sessions);

export const selectSessionArray = createSelector(selectSessionEntity, sessionSelectors.selectAll);
export const selectSessionDict = createSelector(selectSessionEntity, sessionSelectors.selectEntities);
export const selectSessionDetailById = (id: string) => createSelector(selectSessionDict, (sessionDict) => {
  return sessionDict?.[id];
});

export const selectSessionsArray = createSelector(selectSessionsEntity, sessionsSelectors.selectAll);
export const selectSessionsDict = createSelector(selectSessionsEntity, sessionsSelectors.selectEntities);
export const selectSessionById = (id: string) => createSelector(selectSessionsDict, (sessionsDict) => {
  return sessionsDict?.[id];
});


